<template>
  <div class="content-modal-edit-work-restriction-day" :class="{ active: isOpen }">
    <!-- Header -->
    <div class="content-header-modal-edit-work-restriction-day">
      <div
        class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center gap-3"
      >
        <CalendarIcon color="#ffffff" />
        <p class="averta-bold label-22 color-white">Pilih Hari/Tanggal Larangan Bekerja</p>
      </div>
      <div class="is-clickable" @click="handleClose">
        <XMarkIcon color="#ffffff" size="12px" />
      </div>
    </div>

    <!-- Body -->
    <div class="content-body-modal-edit-work-restriction-day gap-8">
      <!-- Info Box -->
      <div class="restriction-info-box">
        <div class="restriction-info-icon">
          <CalendarIcon color="#8b080d" size="24" />
        </div>
        <div class="restriction-info-text">
          <p class="averta-bold label-16 color-black">Pilih Hari/Tanggal Larangan Bekerja</p>
          <p class="averta-regular label-14 color-gray">
            Tukang Jagoan Kanggo tidak akan bisa diassign pada hari/tanggal serta sesi dilarang bekerja. Pastikan jadwal ini akurat agar tidak mengganggu operasional.
          </p>
        </div>
      </div>

      <!-- Form Body -->
      <div class="restriction-form-container">
        <!-- Kolom Kiri: Larangan Mingguan -->
        <div class="restriction-column">
          <p class="averta-bold label-12 restriction-column-title">LARANGAN MINGGUAN</p>
          <div class="restriction-weekly-list">
            <div
              v-for="(day, index) in dayList"
              :key="index"
              class="restriction-weekly-item"
              :class="{ 'restriction-weekly-item-active': weeklyChecked[index] }"
            >
              <label class="restriction-checkbox-label">
                <input
                  type="checkbox"
                  :checked="weeklyChecked[index]"
                  @change="toggleWeeklyDay(index)"
                  class="restriction-checkbox"
                />
                <span class="restriction-checkbox-custom" :class="{ checked: weeklyChecked[index] }"></span>
                <span class="averta-regular label-14" :class="{ 'color-red-restriction': weeklyChecked[index] }">{{ day }}</span>
              </label>
              <div class="restriction-session-select-wrapper" v-if="weeklyChecked[index]">
                <select
                  v-model="weeklySession[index]"
                  class="restriction-session-select averta-regular label-12"
                >
                  <option v-for="s in sessionList" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div>
              <div v-else class="restriction-session-placeholder averta-regular label-12">
                Pilih Sesi
              </div>
            </div>
          </div>
        </div>

        <!-- Kolom Kanan: Larangan Tanggal Spesifik -->
        <div class="restriction-column">
          <p class="averta-bold label-12 restriction-column-title">LARANGAN TANGGAL SPESIFIK</p>

          <!-- Calendar -->
          <div class="restriction-calendar-wrapper">
            <v-date-picker
              is-expanded
              color="red"
              @dayclick="onDateClick"
              :attributes="calendarAttributes"
            />
          </div>

          <!-- Tanggal Terpilih -->
          <div class="restriction-selected-dates" v-if="selectedDatesArray.length > 0">
            <p class="averta-bold label-10 restriction-selected-dates-title">TANGGAL TERPILIH</p>
            <div class="restriction-selected-dates-list">
              <div
                v-for="item in selectedDatesArray"
                :key="item.dateStr"
                class="restriction-date-tile"
              >
                <div class="restriction-date-tile-info">
                  <p class="averta-bold label-12">{{ item.formattedDate }}</p>
                  <p class="averta-regular label-10 color-gray">{{ item.dayName }}</p>
                </div>
                <div class="restriction-date-tile-actions">
                  <select
                    v-model="dateSession[item.dateStr]"
                    class="restriction-session-select restriction-session-select-sm averta-regular label-12"
                  >
                    <option v-for="s in sessionList" :key="s.value" :value="s.value">{{ s.label }}</option>
                  </select>
                  <span class="restriction-date-remove is-clickable" @click="removeDate(item.dateStr)">
                    <XMarkIcon color="#ffffff" size="8px" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="content-footer-modal-edit-work-restriction-day">
      <ButtonApp
        height="2.5em"
        :is-bold="true"
        :isSecondary="true"
        :isDisabled="isLoadingSendData"
        @click="handleClose"
      >
        <p class="averta-bold">Batal</p>
      </ButtonApp>

      <ButtonApp
        height="2.5em"
        :is-bold="true"
        :isSecondary="false"
        :isDisabled="isLoadingSendData"
        @click="handleSubmit"
      >
        <p v-if="!isLoadingSendData" class="averta-bold">Simpan</p>
        <p v-else class="averta-bold">Sedang menyimpan...</p>
      </ButtonApp>
    </div>
  </div>
</template>

<script>
import {
  XMarkIcon,
  CalendarIcon
} from '@/components/icons'
import ButtonApp from '@/components/button/ButtonApp'
import { mapGetters } from 'vuex'

export default {
  name: 'ModalEditWorkRestrictionDay',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    ButtonApp,
    XMarkIcon,
    CalendarIcon
  },
  data () {
    return {
      dayList: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
      sessionList: [
        { value: 0, label: 'Seharian' },
        { value: 1, label: 'Pagi' },
        { value: 2, label: 'Sore' }
      ],
      weeklyChecked: { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false },
      weeklySession: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0 },
      dateSession: {},
      isLoadingSendData: false
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl'
    }),
    calendarAttributes () {
      return Object.keys(this.dateSession).map((dateStr) => {
        const [year, month, day] = dateStr.split('-').map(Number)
        return {
          key: dateStr,
          dates: new Date(year, month - 1, day),
          highlight: {
            style: {
              background: '#8b080d'
            },
            contentStyle: {
              color: '#ffffff',
              fontWeight: '600'
            }
          }
        }
      })
    },
    selectedDatesArray () {
      const dayNames = ['MINGGU', 'SENIN', 'SELASA', 'RABU', 'KAMIS', 'JUMAT', 'SABTU']
      const monthNames = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      return Object.keys(this.dateSession).sort().map(dateStr => {
        const parts = dateStr.split('-')
        const dateObj = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]))
        const monthName = monthNames[dateObj.getMonth()]
        return {
          dateStr,
          formattedDate: `${dateObj.getDate()} ${monthName} ${dateObj.getFullYear()}`,
          dayName: dayNames[dateObj.getDay()]
        }
      })
    }
  },
  methods: {
    loadWorkRestrictionData () {
      const payload = {
        url: this.url,
        project_id: this.projectId
      }

      this.$store
        .dispatch('project/workRestrictionDetail', payload)
        .then((result) => {
          const data = result.data && result.data.data ? result.data.data : []

          if (Array.isArray(data)) {
            data.forEach(item => {
              if (item.type === 'DAY') {
                this.weeklyChecked[item.day] = true
                this.weeklySession[item.day] = item.sesi
              } else if (item.type === 'DATE') {
                this.$set(this.dateSession, item.date, item.sesi)
              }
            })
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    toggleWeeklyDay (index) {
      this.$set(this.weeklyChecked, index, !this.weeklyChecked[index])
      if (!this.weeklyChecked[index]) {
        this.$set(this.weeklySession, index, 0)
      }
    },
    onDateClick (day) {
      const dateStr = day.id
      if (dateStr in this.dateSession) {
        this.$delete(this.dateSession, dateStr)
      } else {
        this.$set(this.dateSession, dateStr, 0)
      }
    },
    removeDate (dateStr) {
      this.$delete(this.dateSession, dateStr)
    },
    resetForm () {
      this.weeklyChecked = { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false }
      this.weeklySession = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0 }
      this.dateSession = {}
    },
    handleClose () {
      this.resetForm()
      this.$emit('close')
    },
    handleSubmit () {
      this.isLoadingSendData = true

      const workRestrictionWeekly = {}
      for (let i = 0; i < 7; i++) {
        if (this.weeklyChecked[i]) {
          workRestrictionWeekly[String(i)] = this.weeklySession[i]
        }
      }

      const workRestrictionDate = { ...this.dateSession }

      const payload = {
        url: this.url,
        project_id: this.projectId,
        body: {
          day: workRestrictionWeekly,
          date: workRestrictionDate
        }
      }

      this.$store
        .dispatch('project/workRestrictionDetailUpdate', payload)
        .then((result) => {
          const message = result.data && result.data.message ? result.data.message : 'Data hari/tanggal larangan bekerja telah disimpan'

          this.isLoadingSendData = false

          this.resetForm()
          this.$buefy.toast.open({
            message: message,
            type: 'is-success'
          })

          this.$emit('submitted')
        })
        .catch((err) => {
          console.error(err)
          this.isLoadingSendData = false
        })
    }
  },
  watch: {
    isOpen (newVal) {
      if (newVal) {
        this.loadWorkRestrictionData()
      }
    }
  }
}
</script>

<style scoped>
.content-modal-edit-work-restriction-day {
  position: absolute;
  top: -35%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 50%;
  min-width: 850px;
  max-width: 850px;
  height: max-content;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  border-radius: 1000px;
  background: #ffffff;
  box-shadow: 0px 5px 8px 0px #2525250d;
  transition: top 0.35s ease-in-out, opacity 0.25s ease-in-out, width 0.25s ease-in-out,
    min-width 0.25s ease-in-out, max-width 0.25s ease-in-out, zoom 0.25s ease-in-out,
    border-radius 0.25s ease-in-out;
  opacity: 0;
  zoom: 0;
}

.content-modal-edit-work-restriction-day.active {
  top: 50%;
  opacity: 1;
  width: 100%;
  min-width: 850px;
  max-width: 850px;
  zoom: 1;
  border-radius: 20px;
}

.content-header-modal-edit-work-restriction-day {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 65px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
  background: #8b080d;
}

.content-body-modal-edit-work-restriction-day {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 70vh;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
  overflow-y: auto;
}

.content-footer-modal-edit-work-restriction-day {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 65px;
  justify-content: end;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
  border-top: 1px solid #e1e1e1;
  background: #ffffff;
  gap: 1rem;
}

/* Work Restriction Form Styles */
.restriction-info-box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  padding: 1rem 1.25rem;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
}

.restriction-info-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  background: #fef2f2;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.restriction-info-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.restriction-form-container {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  width: 100%;
  margin-top: 1rem;
}

.restriction-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.restriction-column-title {
  color: rgb(225, 0, 9);
  letter-spacing: 1px;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e1e1e1;
}

.restriction-weekly-list {
  display: flex;
  flex-direction: column;
}

.restriction-weekly-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.75rem;
  margin: 2px 0px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.15s ease;
}

.restriction-weekly-item-active {
  background: #fef2f2;
  border-radius: 6px;
  border-bottom: 1px solid transparent;
  margin: 2px 0px;
}

.restriction-checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  user-select: none;
}

.restriction-checkbox {
  display: none;
}

.restriction-checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.restriction-checkbox-custom.checked {
  background: rgb(225, 0, 9);
  border-color: rgb(225, 0, 9);
}

.restriction-checkbox-custom.checked::after {
  content: '';
  display: block;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-top: -1px;
}

.color-red-restriction {
  color: rgb(225, 0, 9);
  font-weight: 600;
}

.restriction-session-select-wrapper {
  flex-shrink: 0;
}

.restriction-session-select {
  padding: 0.3rem 0.5rem;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  background: #fff;
  color: #333;
  cursor: pointer;
  outline: none;
  min-width: 90px;
  appearance: auto;
}

.restriction-session-select:focus {
  border-color: rgb(225, 0, 9);
}

.restriction-session-select-sm {
  min-width: 80px;
  font-size: 11px;
  padding: 0.25rem 0.4rem;
}

.restriction-session-placeholder {
  color: #bbb;
  padding: 0.3rem 0.5rem;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  min-width: 90px;
  text-align: center;
  background: #fafafa;
}

/* Calendar Wrapper */
.restriction-calendar-wrapper {
  margin-bottom: 1rem;
}

/* Selected Dates */
.restriction-selected-dates {
  margin-top: 0.25rem;
}

.restriction-selected-dates-title {
  color: #888;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
  text-align: center;
  position: relative;
}

.restriction-selected-dates-title::before,
.restriction-selected-dates-title::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #e1e1e1;
  position: absolute;
  top: 50%;
  width: 25%;
}

.restriction-selected-dates-title::before {
  left: 0;
}

.restriction-selected-dates-title::after {
  right: 0;
}

.restriction-selected-dates-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.restriction-date-tile {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  background: #fafafa;
}

.restriction-date-tile-info {
  display: flex;
  flex-direction: column;
}

.restriction-date-tile-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.restriction-date-remove {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e10009;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease;
}

.restriction-date-remove:hover {
  background: #c20008;
}
</style>

<style>
.restriction-calendar-wrapper .vc-container {
  border: none;
}

.restriction-calendar-wrapper .vc-day-content:hover {
  background-color: rgba(139, 8, 13, 0.12) !important;
  color: #8b080d !important;
  font-weight: 600;
}
</style>
